import React, { Component } from 'react';

import {Elements, injectStripe, StripeProvider} from "react-stripe-elements";
import {STRIPE_API_KEY} from "../Const";
import CreateAccountForm from "./CreateAccountForm";

class StripeAccountEditor extends Component {

    render() {
            return (
                <CreateAccountForm {...this.props}/>
            )
        }
}

// Wrap StripeAccountEditor in a higher-order component that provides the `stripe` prop:
const InjectedPartner = injectStripe(StripeAccountEditor);

class PartnerAccountEditor extends Component {

    render() {

        return <div>
            <StripeProvider apiKey={STRIPE_API_KEY}>
            <Elements>
                <InjectedPartner {...this.props}/>
            </Elements>
            </StripeProvider>
        </div>
    }
}


export default PartnerAccountEditor;
